'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = NotFoundMobile;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Home = require('components/Mobile/Home/');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function NotFoundMobile() {
  return _react2.default.createElement(
    'div',
    { style: { display: 'flex', flexDirection: 'column' } },
    _react2.default.createElement(
      'h3',
      { style: { textAlign: 'center' } },
      'Trang c\u1EE7a b\u1EA1n kh\xF4ng t\xECm th\u1EA5y'
    ),
    _react2.default.createElement(_Home.FeaturedHomeMobile, {
      name: '\u0110\u1ECBa \u0111i\u1EC3m n\u1ED5i b\u1EADt',
      slogan: 'Kh\xE1m ph\xE1 n\u01A1i l\xE0m \u0111\u1EB9p \u0111\u01B0\u1EE3c xem nhi\u1EC1u tr\xEAn Lookme',
      collection: false
    }),
    _react2.default.createElement(_Home.SuggestHomeMobile, null)
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/NotFound/NotFoundMobile.js
// module id = 1616
// module chunks = 0